/**
 * Global money formatter for B2B scripts (non-module, loads before ES modules).
 * Handles all Shopify money_format placeholders including amount_no_decimals_with_space_separator.
 */
(function () {
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    var c = Number(cents);
    if (!isFinite(c)) return '0';
    var number = (c / 100).toFixed(precision);
    var parts = number.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var fracPart = parts[1] && precision > 0 ? decimal + parts[1] : '';
    return intPart + fracPart;
  }

  function valueForPlaceholder(cents, name) {
    var key = String(name || '').trim().toLowerCase();
    switch (key) {
      case 'amount':
        return formatWithDelimiters(cents, 2, ',', '.');
      case 'amount_no_decimals':
        return formatWithDelimiters(cents, 0, ',', '.');
      case 'amount_with_comma_separator':
        return formatWithDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return formatWithDelimiters(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return formatWithDelimiters(cents, 2, "'", '.');
      case 'amount_no_decimals_with_space_separator':
        return formatWithDelimiters(cents, 0, ' ', '.');
      case 'amount_with_space_separator':
        return formatWithDelimiters(cents, 2, ' ', ',');
      case 'amount_with_period_and_space_separator':
        return formatWithDelimiters(cents, 2, ' ', '.');
      default:
        return formatWithDelimiters(cents, 0, ' ', '.');
    }
  }

  function normalizeTemplate(str) {
    return String(str || '')
      .replace(/\uFF5B/g, '{')
      .replace(/\uFF5D/g, '}')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&#123;/g, '{')
      .replace(/&#125;/g, '}');
  }

  function getFormatTemplate(useCurrency) {
    var jj = window.__jjMoney || {};
    var tv = window.themeVariables && window.themeVariables.settings;
    var useCur = useCurrency != null ? useCurrency : !!(jj.currencyCodeEnabled || (tv && tv.currencyCodeEnabled));

    if (useCur) {
      return jj.moneyWithCurrencyFormat || (tv && tv.moneyWithCurrencyFormat) || jj.moneyFormat || (tv && tv.moneyFormat) || '';
    }
    return jj.moneyFormat || (tv && tv.moneyFormat) || '';
  }

  function applyFormat(cents, formatString) {
    var template = normalizeTemplate(formatString);
    if (!template) {
      return formatWithDelimiters(cents, 0, ' ', '.');
    }

    var placeholderRegex = /\{\{\s*([^}]+?)\s*\}\}/g;
    var result = template.replace(placeholderRegex, function (_match, inner) {
      return valueForPlaceholder(cents, inner);
    });

    if (/\{\{/.test(result) || /%\{/.test(result)) {
      var amount = formatWithDelimiters(cents, 0, ' ', '.');
      var suffix = '';
      var closeIdx = template.indexOf('}}');
      if (closeIdx !== -1) {
        suffix = template.slice(closeIdx + 2).trim();
      }
      var currency = (window.__jjMoney && window.__jjMoney.currency) || '';
      if (!suffix && currency) {
        suffix = currency;
      }
      return suffix ? amount + ' ' + suffix : amount;
    }

    return result;
  }

  window.__jjMoney = window.__jjMoney || {};
  if (!window.__jjMoney.moneyFormat && window.themeVariables && window.themeVariables.settings) {
    window.__jjMoney.moneyFormat = window.themeVariables.settings.moneyFormat;
    window.__jjMoney.moneyWithCurrencyFormat = window.themeVariables.settings.moneyWithCurrencyFormat;
    window.__jjMoney.currencyCodeEnabled = window.themeVariables.settings.currencyCodeEnabled;
  }

  window.jjFormatMoney = function (cents, options) {
    options = options || {};
    var useCurrency = options.useCurrencyFormat;
    if (options.currency) {
      window.__jjMoney.currency = options.currency;
    }
    var template = options.format || getFormatTemplate(useCurrency);
    return applyFormat(cents, template);
  };
})();
